import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { BeneficiarySelectionComponent } from '../beneficiary-selection/beneficiary-selection.component';
import { PeerToPeerComponent } from '../peer-to-peer/peer-to-peer.component';
import { SidePanelService } from '@lib/services';

export enum ETransferFlow {
    PEER_TO_PEER = 'PEER_TO_PEER',
    INTRA_WALLET = 'INTRA_WALLET',
}

@Component({
    selector: 'app-transfer-money',
    templateUrl: './transfer-money.component.html',
    styleUrls: ['./transfer-money.component.scss'],
    standalone: true,
    imports: [AngularMaterialModule],
    providers: [SidePanelService],
})
export class TransferMoneyComponent {
    protected transferType: typeof ETransferFlow = ETransferFlow;

    constructor(
        public dialogRef: MatDialogRef<TransferMoneyComponent>, 
        @Inject(MAT_DIALOG_DATA) public data: { message: string }, 
        private readonly dialog: MatDialog, 
        private readonly sidePanel: SidePanelService
    ) {}

    selectPeerToPeer(selectedTransferType: ETransferFlow) {
        this.dialogRef.close();
        const renderTransferFlow = selectedTransferType === ETransferFlow.INTRA_WALLET ? PeerToPeerComponent : BeneficiarySelectionComponent
        this.sidePanel.open(renderTransferFlow, { data: { selectedTransferType }});
    }
}
